var React = require('react');

function ArrowSectors (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M127.533 93.5054L22 267.594L129.545 445","stroke":"#FEE2E2","strokeWidth":"36","key":0}),React.createElement("path",{"d":"M127.533 10L22 184.088L129.545 361.495","stroke":"#FCA5A5","strokeWidth":"36","key":1})]);
}

ArrowSectors.defaultProps = {"width":"78","height":"455","viewBox":"0 0 78 455","fill":"none"};

module.exports = ArrowSectors;

ArrowSectors.default = ArrowSectors;
